import { render, staticRenderFns } from "./RecoverChangesModal.vue?vue&type=template&id=37e7c940&scoped=true&"
import script from "./RecoverChangesModal.vue?vue&type=script&lang=js&"
export * from "./RecoverChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./RecoverChangesModal.vue?vue&type=style&index=0&id=37e7c940&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e7c940",
  null
  
)

export default component.exports